export default "__VITE_ASSET__gzwx9Ot9__"